<template>
  <div id="sevenIntelligencesPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="نمودار هوش هشتگانه"></ActionBar>
    <div class="container mx-auto no-gutters p-0 mt-2">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب سال:</span></div>
          <v-select
              v-model.number="selectedYear"
              :items="years"
              :menu-props="{ down: true, offsetY: true }"
              class="input-border"
              dense
              hide-details
              placeholder="انتخاب سال"
              solo
              @change="setYear">
          </v-select>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب ماه:</span></div>
          <v-select
              ref='monthPicker'

              v-model.number="selectedMonth"
              :disabled="!showMonthPicker"
              :items="months"
              :menu-props="{value:openMonthPicker,down: true, offsetY: true }"
              class="input-border"
              dense
              hide-details
              item-text="text"
              item-value="id"
              placeholder="انتخاب ماه"
              solo
              @change="setDate"
              @click="openMonthPicker  = true">
          </v-select>
        </div>
        <div class="col-6 col-sm-4 col-md-2 text-left align-self-end">
          <v-btn :disabled="selectedYear === null || selectedMonth===null" block class="px-8" color="primary" rounded
                 @click="searchResult">
            جستجو
          </v-btn>
        </div>
      </div>
    </div>
    <div class="row container mx-auto no-gutters p-0 mt-10">
      <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
        در حال جستجو
        <v-progress-linear
            color="deep-purple accent-4"
            height="6"
            indeterminate
            rounded
        ></v-progress-linear>
      </div>
      <div v-else-if="isLoaded" class="col-12 ">
        <div v-if="!hasReport" class="mx-2 mt-5 row knowledge-base-body">
          <div class="col-12  col-sm-10 col-md-6 mx-auto">
            <v-alert
                border="bottom"
                class="text-center"
                color="forth"
                dark>
              گزارشی برای تاریخ انتخاب شده وجود ندارد.
            </v-alert>
          </div>
        </div>
        <div v-else class="row">
          <div class=" col-sm-10 col-md-5 col-12 mx-auto">
            <v-simple-table
                class="border"
                fixed-header>
              <thead>
              <tr>
                <th class="border-left">
                  نوع هوش
                </th>
                <th class="border-left">
                  زمان استاندارد
                </th>
                <th class="border-left">
                  زمان شما
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(item,index) in tableItems"
                  :key="index">
                <td class="border-left">{{ item.name }}</td>
                <td class="border-left">{{ item.standardData }}</td>
<!--                <td class="border-left">{{ $roundNum(item.userData) }}</td>-->
                                <td class="border-left">{{ (item.userData.toFixed(0)) }}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div class="col-12 col-sm-10 col-md-7 mx-auto">
            <MultipleBarChart v-if="isChartLoaded"
                              :chart-label="loadChartLabel()"
                              :chart-standard-data="loadChartStandardData()"
                              :chart-user-data="loadChartUSerData()"
                              :standard-label="'زمان استاندارد'"
                              :user-label="'زمان شما'"/>
          </div>
        </div>
      </div>
    </div>

    <FooterMenu/>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import ActionBar from "../../components/ActionBar";
import FooterMenu from "../../components/FooterMenu";
import MultipleBarChart from "../../components/MultipleBarChart";


let _this = null

export default {
  name: "SevenIntelligences",
  metaInfo: {
    title: 'مسیربرتر-نمودار هوش هشتگانه'
  },
  components: {MultipleBarChart, FooterMenu, ActionBar},
  data: () => ({
    startDate: null,
    endDate: null,
    selectedMonth: null,
    months: [
      {id: 1, text: 'فروردین'},
      {id: 2, text: 'اردیبهشت'},
      {id: 3, text: 'خرداد'},
      {id: 4, text: 'تیر'},
      {id: 5, text: 'مرداد'},
      {id: 6, text: 'شهریور'},
      {id: 7, text: 'مهر '},
      {id: 8, text: 'آبان '},
      {id: 9, text: 'آذر '},
      {id: 10, text: 'دی'},
      {id: 11, text: 'بهمن'},
      {id: 12, text: 'اسفند '},
    ],
    openMonthPicker: false,
    showMonthPicker: false,
    years: [],
    selectedYear: null,
    classId: null,
    classesItems: [],
    dataLoading: false,
    isLoaded: false,
    hasReport: false,
    isChartLoaded: false,
    chartLabel: [],
    chartData: [],
    tableItems: [],
  }),
  mounted() {
    _this = this
    let year = this.$convertDate((new Date()).toISOString()).slice(0, 4)
    this.years.push(year - 1, parseInt(year))


  },
  methods: {
    setYear() {
      this.showMonthPicker = true
      // this.openMonthPicker = true
    },
    setDate() {
      this.openMonthPicker = null
      this.startDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).startDate
      this.endDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).endDate


    },
    loadChartStandardData() {
      let arr = this.chartStandardData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartUSerData() {
      let arr = this.chartUserData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i].toFixed(0));
      }
      return res;

    },
    loadChartLabel() {
      let arr = this.chartLabel;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    inputDatePicker1() {
      this.menu1 = false

      this.inputDate1 = moment(this.date1).format('jYYYY/jMM/jDD')
    },
    inputDatePicker2() {
      this.menu2 = false
      this.inputDate2 = moment(this.date2).format('jYYYY/jMM/jDD')
    },
    searchResult() {
      this.dataLoading = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", this.startDate);
      urlencoded.append("EndDate", this.endDate);
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_SevenIntelligences", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.isLoaded = true
            if (json.length > 0) {
              this.hasReport = true
              this.isChartLoaded = true
              let items = json
              let labels = ['تصویری-فضایی', 'کلامی-زبانی', 'منطقی-ریاضی', 'جسمی-حرکتی', 'موسیقیایی', 'برون فردی', 'درون فردی', 'طبیعت گرا']
              let standardData = []
              let tasviri = 0;
              let kalami = 0;
              let manteghi = 0;
              let jesmi = 0;
              let musighi = 0;
              let borunFardi = 0;
              let darunFardi = 0;
              let tabiatGera = 0;

              for (let i = 0; i < items.length; i++) {
                standardData.push(items[i].GradeEffectTasviri,
                    items[i].GradeEffectKalami,
                    items[i].GradeEffectManteghi,
                    items[i].GradeEffectJesmi,
                    items[i].GradeEffectMusighi,
                    items[i].GradeEffectBorunFardi,
                    items[i].GradeEffectDaorunFardi,
                    items[i].GradeEffectTabiatGera,)

                tasviri += items[i].TotalEffectTasviri
                kalami += items[i].TotalEffectKalami
                manteghi += items[i].TotalEffectManteghi
                jesmi += items[i].TotalEffectJesmi
                musighi += items[i].TotalEffectMusighi
                borunFardi += items[i].TotalEffectBorunFardi
                darunFardi += items[i].TotalEffectDaorunFardi
                tabiatGera += items[i].TotalEffectTabiatGera

              }
              _this.tableItems = [
                {name: 'تصویری-فضایی', userData: tasviri, standardData: standardData[0]},
                {name: 'کلامی-زبانی', userData: kalami, standardData: standardData[1]},
                {name: 'منطقی-ریاضی', userData: manteghi, standardData: standardData[2]},
                {name: 'جسمی-حرکتی', userData: jesmi, standardData: standardData[3]},
                {name: 'موسیقیایی', userData: musighi, standardData: standardData[4]},
                {name: 'برون فردی', userData: borunFardi, standardData: standardData[5]},
                {name: 'درون فردی', userData: darunFardi, standardData: standardData[6]},
                {name: 'طبیعت گرا', userData: tabiatGera, standardData: standardData[7]},
              ]

              this.chartUserData = [tasviri, kalami, manteghi, jesmi, musighi, borunFardi, darunFardi, tabiatGera]
              this.chartLabel = labels
              this.chartStandardData = standardData

            } else {
              this.hasReport = false
            }

            this.dataLoading = false
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>
